// extracted by mini-css-extract-plugin
export var fullWidthButton = "_e8-0";